import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
  RoutesRecognized,
} from '@angular/router';
import { PreviousRouteService } from './../../../../sdk/services/custom/previous-route.service';

import { CommonModule, isPlatformBrowser, Location } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzMessageService } from 'ng-zorro-antd/message';
import { filter, pairwise } from 'rxjs/operators';
import { AuthService } from '../../../../sdk/services/core/auth.service';
import { MiscHelperService } from '../../../../sdk/services/custom/miscHelperService.service';
import { NotificationsApi } from '../../../../sdk/services/custom/notifications.service';
import { NavbarRerenderService } from '../../../../sdk/services/helper/navbar-rerender.service';
import { Unlockdconfig } from '../../../../sdk/unlockd.config';
import { url } from './../../../cloudFrontUrl';

@Component({
  selector: 'app-topnavbar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NzLayoutModule,
    NzGridModule,
    NzMenuModule,
    NzButtonModule,
    NzDropDownModule,
    NzIconModule,
    NzBadgeModule,
  ],
  templateUrl: './topnavbar.component.html',
  styleUrls: ['./topnavbar.component.scss'],
})
export class TopnavbarComponent implements OnInit, OnDestroy, AfterContentChecked {
  assetUrl: string;
  size = 'large';
  navToggle = false;
  currentUrl: string;
  isCollapsed = false;
  hideNavbar = false;
  account_name: string;
  isLogin = false;
  loading = false;
  isAdmin = false;
  isTab: boolean = false;
  unread_notifications = 0;
  user_id = '';
  notifications = [];
  navbarColorChange = true;
  homePage = true;
  avatarUrl: string;
  displayLetters: string;
  color = 'white';
  mobileNavToggle = true;
  loginSignupTitle = 'login';
  displayLogin = false;
  loginVisible = false;
  hideNav = false;
  isMobile = false;
  showDropDown: boolean = false;
  showDropDownMobileSell: boolean = false;
  showDropDownMobileResearch: boolean = false;
  showDropDownMobileWhyFalaya: boolean = false;
  showWebDropDown: boolean = false;
  showWebDropDown1: boolean = false;
  showWebDropDownSell: boolean = false;
  isHome: boolean = false;
  isNewHome: boolean = false;
  isHeaderTopColored: boolean = false;
  previousRoute: string;
  @Output() mobileMenuToggelled = new EventEmitter();
  @ViewChild('NavBarNotificationDropDownHost', {
    read: ViewContainerRef,
    static: false,
  })
  public NavBarNotificationDropDownHost: ViewContainerRef;
  NavBarNotificationDropDownContainer;

  @ViewChild('loginHost', { read: ViewContainerRef, static: false })
  loginHost: ViewContainerRef;

  constructor(
    private authService: AuthService,
    private notificationsApi: NotificationsApi,
    public router: Router,
    private message: NzMessageService,
    private navbarRerenderService: NavbarRerenderService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private pr: PreviousRouteService,
    private miscHelperService: MiscHelperService,
    private _location: Location,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.assetUrl = url;
    this.previousRoute = this.authService.getRoute();
    
    
    router.events
      .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
      .subscribe((events: RoutesRecognized[]) => {
        // console.log('events[1]: ', events[1].urlAfterRedirects)
        this.authService.setRoute(events[1].urlAfterRedirects);
        if (events[1].urlAfterRedirects.includes('listings')) {
          if (this.previousRoute == 'sell') {
          }
        }
        
        if (!(events[1].urlAfterRedirects.length > 2)) {
          // this.hideNavbar = true;
          // setTimeout(() => {
          //   window.resizeTo(10, 10);
          //   console.log('resize');

          // }, 3000);

          // setTimeout(() => {
          //   let Page = document.getElementById('container');
          //   let zoom = '150%'
          //   Page.style.zoom = zoom
          // }, 2000);

          setTimeout(() => {
            

            window.location.href = '/'
            // this.router.navigate(['/'])
            // .then(() => {
            //   window.location.reload(false);
            // });
          }, 0);

          // setTimeout(() => {
          //   let Page = document.getElementById('container');
          //   let zoom = '100%'
          //   Page.style.zoom = zoom;
          //   console.log('page', Page);
          //   window.resizeTo(10, 10);
          //   window.resizeBy(10, 10);
          //   console.log('window', window);
          // }, 3000);
        }
      });

    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))

      .subscribe(() => {

        this.currentUrl = this.router.url;
        this.authService.setRoute(this.currentUrl);
        if (this.previousRoute?.includes('listings') || this.previousRoute?.includes('listing-payment')) {
          setTimeout(() => {
            window.location.href =this.currentUrl
          }, 0);

        }
        
        if (
          this.router.url.includes('home') ||
          this.router.url.includes('buy') ||
          this.router.url.includes('sell') ||
          this.router.url.includes('confirmation') ||
          this.router.url == '/' ||
          this.router.url == '' ||
          this.router.url == '/terms/privacy-policy' ||
          this.router.url == '/terms/tos'
          //  this.router.url.includes('new-home')
        ) {
          this.homePage = true;
          let el: any = document.querySelector('.header-top');
          el.classList.remove('header-top-colored');
          el.classList.remove('nav-active');
          document.body.classList.remove('no-scroll-y');
        } else {
          this.homePage = false;
        }
        

        if (
          this.router.url.includes('pricing') ||
          this.router.url.includes('comparison') ||
          this.router.url.includes('about-us') ||
          this.router.url.includes('listings') ||
          this.router.url == '/contact'
        ) {
          this.color = 'primary';
          document.body.classList.remove('no-scroll-y');
        } else {
          this.color = 'white';
        }

        if (
          this.router.url.includes('signup') ||
          this.router.url.includes('login') ||
          this.router.url.includes('forgot') ||
          this.router.url.includes('password-recovery') ||
          this.router.url.includes('guide') ||
          this.router.url.includes('flat')
        ) {
          //console.log('should be hidden now')
          this.hideNavbar = true;
        } else {
          this.hideNavbar = false;
        }
        this.mobileNavToggle = true;
        if (this.NavBarNotificationDropDownContainer) {
          this.NavBarNotificationDropDownContainer.instance.color = this.color;
          this.NavBarNotificationDropDownContainer.instance.ngOnChanges();
        }

      });
    this.miscHelperService.setTimeoutCustom(() => this.setChanged(), 0);
  }
  ngAfterContentChecked(): void {
    // if (this.router.url === '/new-home') {
    //     let el: any = document.querySelector('header-top');
    //     console.log('el',el)
    //     }
  }
  setChanged() {
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }
  ngOnInit() {
    // debugger;

    this.conditionRender();
    this.checkMobile();
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('scroll', this.scroll, {passive: true}); //third parameter
    }
    // console.log('router here:',this.router.url)
    this.navbarRerenderService.newCurrentMessage.subscribe((message) => {
      // console.log(message)
    })
    this.navbarRerenderService.currentMessage.subscribe((message) => {
      // console.log('message to be subbed',message)
      if (message === 'rerender' || message === 'rerenderdashboard') {
        this.conditionRender();
      }
      this.isHome = this.navbarRerenderService.getIsHome();



      // Its True if the scroller on Home Page is at the Top otherwise False
      if (message === 'navbarColorChangeTrue') {
        this.navbarColorChange = true;
      }
      if (message === 'navbarColorChangeFalse') {
        this.navbarColorChange = false;
      }

      
      if (
        this.router.url.includes('pricing') ||
        this.router.url.includes('comparison') ||
        this.router.url.includes('about-us') ||
        this.router.url.includes('listings') ||
        this.router.url == '/contact'

      ) {
        this.color = 'primary';
      } else {
        this.color = 'white';
      }
      // Check if The current page is home page
      if (
        this.router.url == '/' ||
        this.router.url.includes('home') ||
        this.router.url.includes('buy') ||
        this.router.url.includes('sell') ||
        this.router.url == '/features' ||
        this.router.url == '' ||
        this.router.url == '/confirmation'||
        this.router.url == '/terms/privacy-policy' ||
        this.router.url == '/terms/tos'  || 
        this.router.url.includes('meeting-booked')
      ) {
        // console.log('1')
        let el: any = document.querySelector('.header-top');
        if (el) {
          el.classList.remove('header-top-colored');
          document.body.classList.remove('no-scroll-y');
        }


        if (this.router.url.includes('home') || this.router.url == '' || this.router.url == '/' || this.router.url.includes('flat-fee-mls-listings')) {
          // console.log('2')
          let el: any = document.querySelector('.header-top');
          el.classList.add('header-top-colored');
          this.isNewHome = false;
          this.isHeaderTopColored = true;
        }
        this.homePage = true;
      } else {
        this.homePage = false;
        this.isHeaderTopColored = false;
      }

      if(this.router.url.includes('homes-for-sale')){
        // console.log("////",this.router.url.includes('homes-for-sale'));
        let el: any = document.querySelector('.header-top');
        el.classList.remove('header-top-colored');
        el.classList.add('nav-active')
      }

    });
    if (this.route.snapshot.queryParamMap.get('fromBlog')) {
      this.logout();
    }

    if(this.router.url.includes('homes-for-sale')){
      // console.log(this.router.url.includes('homes-for-sale'));
      let el: any = document.querySelector('.header-top');
      el.classList.remove('header-top-colored');
      el.classList.add('nav-active')
    }
  }

  toggleNav() {
    this.navToggle = !this.navToggle;
  }


  scroll = (event: any): void => {
    const verticalOffset =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    // If verticalOffset is 0, it means the scroller is at the top
    let el: any = document.querySelector('.header-top');
    // console.log('offset: ',verticalOffset)
    if (verticalOffset <= 100) {
      if (this.router.url.includes('home') || this.router.url == '' || this.router.url == '/') {
          // console.log('includes home', this.router.url)
        // console.log('did I do it?')
        el.classList.remove('nav-active')
        el.classList.add('header-top-colored');
        this.homePage = true;
      } else {
        if (
          this.router.url.includes('buy') ||
          this.router.url.includes('sell') ||
          this.router.url == '/features' ||
          this.router.url == '/terms/privacy-policy' ||
          this.router.url == '/terms/tos' ||
          this.router.url.includes('meeting-booked')
        ) {
          this.homePage = true;
        } else {
          this.homePage = false;
        }
      }
    } else {
      if (this.router.url.includes('home') || this.router.url == '' || this.router.url == '/') {
        el.classList.remove('header-top-colored');
        el.classList.add('nav-active')
      } else {}
    }
  };


  toggleMobileNav() {
    // if (this.mobileNavToggle) {
    //   this.mobileMenuToggelled.emit(false)
    // } else {
    //   this.mobileMenuToggelled.emit(true)
    // }
    // this.mobileNavToggle = !this.mobileNavToggle;
    document.body.classList.toggle('no-scroll-y'); 
    this.mobileNavToggle = !this.mobileNavToggle;
    this.navbarRerenderService.mobileNavToggle.next(true);
  }
  logout() {
    this.authService.logout('/');
    this.navbarRerenderService.changeMessage('refreshhomedata');
    this.conditionRender();
    this.navbarRerenderService.changeMessage('refreshhomedata');
  }
  toggleIsCollapse() {
    this.navbarRerenderService.changeMessage('toggle');
    this.isCollapsed = !this.isCollapsed;
  }
  openHelpCenter() {
    const url = 'https://unlockdhelp.freshdesk.com/';
    window.open(url, '_blank');
  }
  @HostListener('window:resize', ['$event'])
  @HostListener('window:load', ['$event'])
  onEvent(event) {
    this.checkMobile();
  }
  checkMobile() {
    const windowWidth =
      window.screen.width < window.outerWidth
        ? window.screen.width
        : window.outerWidth;
    if (windowWidth < 480) {
      this.isMobile = true;
    } else if (windowWidth <= 1024 && windowWidth > 480) {
      this.isTab = true;
    } else {
      this.isMobile = false;
    }
  }
  openCMS() {
    window.location.href = `https://falaya.com/research/learn/?env=${Unlockdconfig.getEnvironment()}&user_id=${this.user_id}`;
  }

  navigateToArticles() {
    window.location.href = `https://falaya.com/research/learn/?env=${Unlockdconfig.getEnvironment()}&user_id=${this.user_id}`;
  }
  toggleDropDown(slectedMenu) {
    if(slectedMenu == 'sell')
    this.showDropDownMobileSell = !this.showDropDownMobileSell;
    if(slectedMenu == 'why falaya')
    this.showDropDownMobileWhyFalaya = !this.showDropDownMobileWhyFalaya;
    if(slectedMenu == 'research')
    this.showDropDownMobileResearch = !this.showDropDownMobileResearch;
    if (this.showDropDownMobileSell) {
      let el: any = document.querySelector('.mobile-menu');
      el.style.overflow = "auto";
    }
  }
  close() {
    this.showDropDownMobileSell = false;
    this.showDropDownMobileWhyFalaya = false;
    this.showDropDownMobileResearch = false;
  }
  mouseEnter() {
    // console.log('mouse enter')
    this.showWebDropDown = true;
  }
  mouseLeave() {
    this.showWebDropDown = false;
    // console.log('left')
  }

  mouseEnter1() {
    // console.log('mouse enter')
    this.showWebDropDown1 = true;
  }
  mouseLeave1() {
    this.showWebDropDown1 = false;
    // console.log('left')
  } 
  mouseEnterSell() {
    // console.log('mouse enter')
    this.showWebDropDownSell = true;
  }
  mouseLeaveSell() {
    this.showWebDropDownSell = false;
    // console.log('left')
  }



  conditionRender() {
    try {
      const access_token = this.authService.getAccessTokenId();
      if (access_token) {
        const {
          first_name,
          last_name,
          role,
          profile_image,
          unlockd_user,
          id,
        } = this.authService.getAccessTokenInfo();
        this.user_id = id;
        if (last_name) {
          this.account_name = first_name + ' ' + last_name;
          const fullName = this.account_name;
          if(fullName.length > 16){
            this.account_name = first_name + ' ' + last_name.charAt(0).toUpperCase() + '.';
          }else{
            this.account_name = fullName;
          }
          // console.log('here goes the user name: ', this.account_name);
        } else {
          this.account_name = first_name;
        }

        this.displayLetters = this.getNameLetters(this.account_name);

        if (role === 'admin') {
          this.isAdmin = true;
        } else {
          this.isAdmin = false;
        }
        this.isLogin = true;
        if (profile_image) {
          if (profile_image) {
            if (unlockd_user) {
              this.avatarUrl = profile_image + '?' + new Date().getTime();
            } else {
              this.avatarUrl = profile_image;
            }
          }
        }
        this.getAll();
        if (this.isLogin) {
          this.loadNavBarNotificationDropDown();
        }
      } else {
        this.isLogin = false;
        this.account_name = '';
        this.avatarUrl = '';
      }
    } catch (error) {
      console.log('error', error);
      this.isLogin = false;
    }
  }
  getAll() {
    this.loading = true;
    this.notificationsApi.getNotificationsByUserId().subscribe(
      (data) => {
        if (data.data && data.data.notifications) {
          this.notifications = data.data.notifications;
        }
        // this.notificationsLength = data.data.count;
        this.unread_notifications = data.data.unread;
        this.loading = false;
      },
      (error) => {
        console.log('error', error);
        this.loading = false;
      }
    );
  }
  getNameLetters(name: string) {
    let letter = '';

    name
      .trim()
      .split(' ')
      .forEach((l) => (letter = letter + l.charAt(0).toUpperCase()));
    return letter.substring(0, 2);
    // return letter;
  }
  ngOnDestroy() {
    this.NavBarNotificationDropDownHost?.clear();
  }
  loadNavBarNotificationDropDown() {
    import('../navbar-notification-dropdown/navbar-notification-dropdown.component').then(
      ({ NavbarNotificationDropdownComponent }) => {
        this.NavBarNotificationDropDownHost?.clear();
        this.NavBarNotificationDropDownContainer =
          this.NavBarNotificationDropDownHost.createComponent(
            NavbarNotificationDropdownComponent
          );
        if (!this.isNewHome) {
          this.NavBarNotificationDropDownContainer.instance.color = 'primary';
        } else {
          this.NavBarNotificationDropDownContainer.instance.color = 'white';
        }
      }
    );
  }

  listAPropertyClick() {
    // this.listAPropertyService.changeMessage(true);
    if (this.isLogin === true) {
      const url = '/listing';
      this.router.navigateByUrl(url);
    } else {
      const message = `Please Log In or Join Falaya to sell a listing`;
      this.displayLoginNotification(message);
      // this.openLoginModalTimeout();
      this.listAPropertyPaymentSignin();
    }
  }
  listAPropertyPaymentClick() {
    // this.listAPropertyService.changeMessage(true);
    if (this.isLogin === true) {
      const url = '/listing-payment';
      this.router.navigateByUrl(url);
    } else {
      const message = `Please Log In or Join Falaya to sell a listing`;
      this.displayLoginNotification(message);
      // this.openLoginModalTimeout();
      this.listAPropertyPaymentSignin();
    }
  }
  listAPropertySignin() {
    const url = '/signup'
    const gotoListing = '/listing';
    this.pr.goto = gotoListing;
    this.router.navigateByUrl(url);
  }
  listAPropertyPaymentSignin() {
    const url = '/signup'
    const gotoListing = '/listing-payment';
    this.pr.goto = gotoListing;
    this.router.navigateByUrl(url);
  }

  displayLoginNotification(message) {
    this.message.info(message, {
      nzDuration: 3000
    });
  }
  openLoginModalTimeout() {
    // this will run after 3 seconds so once the message completes
    this.miscHelperService.setTimeoutCustom(() => {
      this.openLoginModal();
      this.hideNavbar = true;
    }, 2000);
  }
  openLoginModal() {
    // this.displayLogin = false;

    this.loadSignupComponent();
    this.loginSignupTitle = 'login';
  }
  closeLoginModal() {
    this.loginHost?.clear();
  }
  loginSignupSuccess() {
    this.displayLogin = false;
    this.hideNavbar = false;
    this.loginVisible = false;
    this.conditionRender();
  }
  loginSignupToggle() {
    this.displayLogin = !this.displayLogin;
    if (this.displayLogin) {
      this.loginSignupTitle = 'Signup';
    } else {
      this.loginSignupTitle = 'Login';
    }
  }
  loadLoginComponent() {
    import('../../../login-shared/login-shared.component').then(
      ({ LoginSharedComponent }) => {
        this.loginHost?.clear();
        const ref = this.loginHost.createComponent(LoginSharedComponent);
        ref.instance.loginFromModal = true;
        ref.instance.loginSignupSuccess.subscribe((data) => {
          this.loginSignupSuccess();
        });
        ref.instance.displaySignup.subscribe((data) => {
          this.loginHost?.clear();
          // this.loginHost.clear();
          this.loadSignupComponent();
        });
      }
    );
  }

  loadSignupComponent() {
    import('../../../signup-shared/signup-shared.module').then(
      ({ SignupSharedModule }) => {
        const loginComp = SignupSharedModule.getSignupComponent();
        this.loginHost?.clear();
        const ref = this.loginHost.createComponent(loginComp);
        ref.instance.loginFromModal = true;
        this.loginVisible = true;
        ref.instance.loginSignupSuccess.subscribe((data) => {
          this.loginSignupSuccess();
        });
        ref.instance.displayLogin.subscribe((data) => {
          this.loginHost?.clear();
          // this.loginHost.clear();
          this.loadLoginComponent();
        });
      }
    );
  }
  loginClicked() {
    this.pr.goto = '';
  }
  signupClicked() {
    this.pr.goto = '';
  }
  navigated() {
    // console.log('call me clicked:')
    this.mobileMenuToggelled.emit(true)
  }
  navigateToUrl(url) {
    const routes = {
      blog: 'https://falaya.com/research/learn/',
      faq: 'https://falaya.com/faqs',
      'legal-doc': 'https://falaya.com/research/real-estate-documents/',
      videos: 'https://falaya.com/research/videos/',
      'seller-guide': 'https://falaya.com/research/home-sellers-guide/',
      features: 'https://falaya.com/features/',
      comparison: 'https://falaya.com/comparison/',
      testimonials: 'https://falaya.com/about-falaya/testimonials/',
      'mobile-app': 'https://falaya.com/about-falaya/falaya-mobile-app/',
      'transaction-management': 'https://falaya.com/about-falaya/transaction-management/',
      team: 'https://falaya.com/about-falaya/about-us/',
      pricing: 'https://falaya.com/pricing/',
      sell: 'https://falaya.com/sell/',
      home:  'https://falaya.com/',
      'property-search': 'https://dev.falaya.com/listings',
      homeOwner:'https://falaya.com/sell/home-owner/',
      investor:'https://falaya.com/sell/real-estate-investor/',
      homeBuilder:'https://falaya.com/sell/home-builder/',
      institutionalInvestor:'https://falaya.com/sell/institutional-investor/'
    };
  
    const route = routes[url];
    if (route) {
      window.location.href = route;
    } else {
      // console.error('Invalid URL key:', url);
    }
  }
  
}